<template lang="pug">
md-layout(md-flex='100')
  license-form-dialog(ref="licenseDialog", @error='onCreateLicenseError', @created='onCreateLicenseSuccess')

  md-layout(md-flex='90')
    md-input-container(:class='{ "md-input-invalid" : showRequiredError }')
      label(for='license') License
      md-select#license(name='license', :multiple='multiple', v-model='selected', @selected='onLicenseSelected')
        md-option(v-for='license in filteredLicenses', :value='license._id', :key='license._id', :class='{ expired: isLicenseExpired(license), draft: isLicenseDraft(license) }') {{ license.name }}
    span.md-error(v-show='showRequiredError') This field is required
  md-layout.add-license-button(md-flex='10', md-align='center')
    md-button.md-icon-button.md-raised.md-dense.md-mini(@click='openLicenseFormDialog')
      md-icon(md-iconset="fa fa-plus")
  span.expired(v-show='hasExpiredLicenses') One or more selected licenses are expired
  span.draft(v-show='hasDraftLicenses') One or more selected licenses are draft
</template>

<script>
  import licenseService from '../../services/licenseService';
  import LicenseFormDialog from '../forms/LicenseFormDialog';

  export default {
    components: {
      LicenseFormDialog
    },
    props: {
      value: {
        type: [String, Array],
        required: true
      },
      multiple: {
        type: Boolean,
        default: false
      },
      showRequiredError: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        selected: this.value,
        licenses: []
      };
    },
    computed: {
      filteredLicenses() {
        return this.licenses.filter(license => {
          const isExpired = this.isLicenseExpired(license);
          const isDraft = this.isLicenseDraft(license);
          const isSelected = this.selected.includes(license._id);
          return (!isExpired && !isDraft) || isSelected;
        });
      },
      hasExpiredLicenses() {
        return this.checkSelectedLicenses(this.isLicenseExpired);
      },

      hasDraftLicenses() {
        return this.checkSelectedLicenses(this.isLicenseDraft);
      }
    },
    methods: {
      onLicenseSelected(value) {
        this.$emit('input', value);
      },

      openLicenseFormDialog() {
        this.$refs.licenseDialog.open();
      },

      onCreateLicenseSuccess(license) {
        this.licenses.push(license);
        if (typeof this.selected === 'string') {
          this.selected = license._id;
        } else {
          this.selected.push(license._id);
        }
        this.$emit('created', 'License created successfully');
      },

      onCreateLicenseError(error) {
        this.$emit('error', error);
      },

      checkSelectedLicenses(condition) {
        const selectedLicenses = Array.isArray(this.selected)
          ? this.selected
          : [this.selected];
        return selectedLicenses.some(id => {
          const license = this.licenses.find(license => license._id === id);
          return license && condition(license);
        });
      },

      isLicenseExpired(license) {
        return new Date(license.endDate) <= new Date();
      },

      isLicenseDraft(license) {
        return license.status === 'draft';
      },
    },
    async mounted() {
      const params = { limit: 100, sortBy: 'name', sortOrder: 'desc'};
      try {
        const response = await licenseService.getList(params);
        this.licenses = response.data.licenses;
      } catch (error) {
        this.$emit('error', 'Error while retrieving the licenses. Please, try again later.');
      }
    },
    watch: {
      value(newValue) {
          this.selected = newValue;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .add-license-button {
    align-items: center;
  }

  .expired {
    color: #d33 !important;
  }

  .draft {
    color: #f90 !important;
  }
</style>



// WEBPACK FOOTER //
// src/shared-components/license/LicenseSelector.vue